import { render, staticRenderFns } from "./parent.vue?vue&type=template&id=15e48161&scoped=true"
import script from "./parent.vue?vue&type=script&lang=js"
export * from "./parent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e48161",
  null
  
)

export default component.exports